import './Cards.scss';
import state from '../../state';
import Sections from './Sections';
import Pics from './Pics';
import Btns from './Btns';
import Brends from './Brends';
import SectionDescription from './SectionDescription';
import SectionSpecifications from './SectionSpecifications';
function Cards() {
    let Cards = state.Cards.map ((card, idx) =>
    {    
        return ( 
        <div  key={idx} className="cart" id={card.id}>
            <div className='wrapper'>
                <div className='card-header'>
                    <h1>{card.title}</h1>
                </div>
                <img  loading="lazy" className="product" alt = "" src = {card.src}></img>
                <div className="awards">
                    {card.awards ? 
                        card.awards.map((award, idx) =>
                            {    
                                return ( 
                                    <img src={award.award} key={idx} className="award" loading="lazy" alt = ""/>
                                )
                            })
                        : ""
                    }
                </div>
                <Btns card = {card}/>
                <p className='desc'>{card.desc}</p>
                <p className='desc-subtitle'>{card.subtitle}</p>
                <p className='desc-text'>{card.text}</p>

            </div>
            <Sections card = {card}/>
            <Pics card = {card} />
            {card.description ? 
                <div className='wrapper'>
                    <div className='description-text'>
                        {card.description}        
                    </div>
                </div>
                : ""
            }
            <SectionSpecifications card = {card} />
            <Brends card = {card} />
            <SectionDescription card = {card} />
        </div>
    )});
return (
    <div className='cardList'>{Cards}</div>
)}
export default Cards;